import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import classNames from 'classnames';

import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';

import { useFormCreateEspecie } from 'src/controllers/Especies/CreateEspecieController';
import LoadingScreen from '../../components/LoadingScreen';

const EspecieForm: React.FC = () => {
    const { getEspecieFormController, handleEspecieFormController } = useFormCreateEspecie();

    const [registerFinished, setRegisterFinished] = useState(false);

    const history = useHistory();

    useEffect(() => {
        if (getEspecieFormController.especieResponse?.status === 200) {
            setRegisterFinished(true);
        }
        if (getEspecieFormController.especieEditedResponse?.status === 200 && !getEspecieFormController.especieResponse) {
            setRegisterFinished(false);
        }
    }, [getEspecieFormController.especieResponse, getEspecieFormController.especieEditedResponse]);

    return (
        <div style={{ height: '100%' }} className="p-grid p-align-center p-justify-center">
            <Toast ref={getEspecieFormController.toast} />
            {getEspecieFormController.loading ? <LoadingScreen color="#0388e5" /> : <></>}
            <div className="p-col-12 p-md-8">
                <div className="card p-fluid">
                    <h5>Especie</h5>
                    <div className="p-field">
                        <label htmlFor="name">Descrição</label>
                        <InputText disabled={registerFinished} id="name" type="text"
                            value={getEspecieFormController.formik.values.DESCRICAO}
                            onChange={getEspecieFormController.formik.handleChange('DESCRICAO')}
                        />
                        <div className={classNames("p-invalid popup-fade", {
                            'popup-form-active': getEspecieFormController.formik.touched.DESCRICAO && getEspecieFormController.formik.errors.DESCRICAO,
                            'popup-form-inactive': !(getEspecieFormController.formik.touched.DESCRICAO && getEspecieFormController.formik.errors.DESCRICAO),
                        })}>{getEspecieFormController.formik.errors.DESCRICAO}</div>
                    </div>

                    <div className="p-fluid p-grid p-justify-between">
                        {getEspecieFormController.especieResponse?.status === 200 && !registerFinished ?
                            <div className="p-col-12 p-md-4">
                                <Button
                                    type="button"
                                    label="Salvar Alterações"
                                    onClick={() => {
                                        getEspecieFormController.formik.handleSubmit()
                                    }}
                                />
                            </div> :
                            getEspecieFormController.especieResponse?.status === 200 && registerFinished ?
                                <div className="p-col-12 p-md-6 p-fluid p-grid" >
                                    <div className="p-col-12 p-md-5">
                                        <Button
                                            type="button"
                                            label="Editar"
                                            onClick={() => {
                                                setRegisterFinished(false);
                                            }}
                                        />
                                    </div>
                                    <div className="p-col-12 p-md-5" >
                                        <Button
                                            icon="pi pi-plus"
                                            type="button"
                                            className="p-button-success"
                                            label="Cadastrar novo"
                                            onClick={() => {
                                                getEspecieFormController.formik.resetForm();
                                                setRegisterFinished(false);
                                                handleEspecieFormController.setEspecieResponse(null);
                                            }}
                                        />
                                    </div>
                                </div> :
                                <div className="p-col-12 p-md-4">
                                    <Button
                                        type="button"
                                        label="Cadastrar"
                                        onClick={() => getEspecieFormController.formik.handleSubmit()}
                                    />
                                </div>
                        }

                        <div className="p-col-12 p-md-4">
                            <Button
                                type="button"
                                className="p-button-secondary"
                                label="Voltar para listagem"
                                onClick={() => history.goBack()}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );
};

export default EspecieForm;